import { useNavigate } from 'react-router'
import { Text } from '@carouselgg/nexus/text'
import { PRIVACY_SECTIONS, PRIVACY_LAST_UPDATED } from '@carouselgg/nexus/legal'
import styles from './LegalPage.module.css'

export function PrivacyPage() {
  const navigate = useNavigate()

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <button type="button" className={styles.backLink} onClick={() => navigate(-1)}>
          <Text size="sm">&larr; Back</Text>
        </button>

        <div className={styles.header}>
          <Text as="h1" size="3xl" weight="bold">
            Privacy Policy
          </Text>
          <Text size="sm" muted className={styles.lastUpdated}>
            Last updated: {PRIVACY_LAST_UPDATED}
          </Text>
        </div>

        <nav className={styles.toc}>
          <Text as="h2" size="base" weight="semibold" className={styles.tocTitle}>
            Contents
          </Text>
          <ol className={styles.tocList}>
            {PRIVACY_SECTIONS.map((section) => (
              <li key={section.id}>
                <a href={`#${section.id}`} className={styles.tocLink}>
                  {section.title}
                </a>
              </li>
            ))}
          </ol>
        </nav>

        <div className={styles.sections}>
          {PRIVACY_SECTIONS.map((section) => (
            <section key={section.id} id={section.id} className={styles.section}>
              <Text as="h2" size="xl" weight="semibold" className={styles.sectionTitle}>
                {section.title}
              </Text>
              <Text muted>{section.content}</Text>
            </section>
          ))}
        </div>
      </div>
    </div>
  )
}
